export const PUBLIC_WEB_CONTENT_TEST_ID = {
    NOT_FOUND_PRIMARY_BUTTON: 'not-found-primary-button',
    NOT_FOUND_SECONDARY_BUTTON: 'not-found-secondary-button',
};
